import { render, staticRenderFns } from "./Co2Report.vue?vue&type=template&id=08a70356&scoped=true"
import script from "./Co2Report.vue?vue&type=script&lang=ts"
export * from "./Co2Report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a70356",
  null
  
)

export default component.exports